// Unpublished Work © 2025 Deere & Company.

import OnLinkIconButton from 'Ui/components/common/onlink-icon-button';
import PropTypes from 'Utils/prop-type-utils';
import React from 'react';
import {Box} from '@deere/isg.component-library';

function ActionsColumn(props) {
    const {actions} = props;

    return (
        <div className='actions-column'>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'end',
                    alignItems: 'center',
                    width: '100%',
                    height: '100%'
                }}
            >
                {
                    actions.map((action, index) => {
                        const IconComponent = action.iconComponent;

                        return (
                            <OnLinkIconButton
                                className={action.buttonClassName}
                                key={index}
                                onClick={action.onClick}
                            >
                                <IconComponent {...action.iconProps}/>
                            </OnLinkIconButton>
                        );
                    })
                }</Box>
        </div>
    );
}

ActionsColumn.propTypes = {
    actions: PropTypes.arrayOf(PropTypes.object)
};

export default ActionsColumn;
